import { FormDateComponent } from './components/form/form-date/form-date.component';
import { FormDropdownComponent } from './components/form/form-dropdown/form-dropdown.component';
import { FormTextComponent } from './components/form/form-text/form-text.component';
import { FormToggleComponent } from './components/form/form-toggle/form-toggle.component';
import { FormTextAreaComponent } from './components/form/form-text-area/form-text-area.component';
import { FormMoneyComponent } from './components/form/form-money/form-money.component';
import { FormPhoneComponent } from './components/form/form-phone/form-phone.component';
import { FormFileAttachmentComponent } from './components/form/form-file-attachment/form-file-attachment.component';
import { CustomDatePickerComponent } from './components/form/custom-date-picker/custom-date-picker.component';

export const UI_FORM_IMPORTS = [
    FormToggleComponent,
    FormTextComponent,
    FormDropdownComponent,
    FormDateComponent,
    FormTextAreaComponent,
    FormMoneyComponent,
    FormPhoneComponent,
    FormFileAttachmentComponent,
    CustomDatePickerComponent
];
